import heart from './heart';
import * as wishlist from './manager';

export default function wishlistToggle() {
    wishlist.list()
        .then(list => {
            const ids = list.map(item => item.ProductClassId);

            [...document.querySelectorAll('[data-heart]')]
                .forEach($element => heart({
                    $element,
                    ids,
                    onChange: ({ id, active, disable, enable }) => {
                        disable();

                        (active ? wishlist.add(id) : wishlist.remove(id)).then(() => enable());
                    }
                }));
        });
}

















































